import { WidgetMode } from "../constants";
import { FeaturedJobsContext, QuickJobsContext, RefinedSearchContext } from "../context";

export const getContextFromWidget = (widgetMode: WidgetMode) => {
  if (widgetMode === 'jobs-search') {
    return RefinedSearchContext;
  }
  if (widgetMode === 'quick-jobs') {
    return QuickJobsContext;
  }
  if (widgetMode === 'featured-jobs') {
    return FeaturedJobsContext;
  }
}